import React, { useState, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';

const ImageSlider = () => {
  const images = [
    '/Images/ImageSlider/image1.jpg',
   '/Images/ImageSlider/image2.jpg',
    '/Images/ImageSlider/image2.jpg',
    // Add more images as required
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(intervalId);
  }, [images.length]);

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: { xs: '370px', sm: '350px', md: '400px' }, // Responsive height
        marginTop: '5px',
        borderRadius: '10px',
        overflow: 'hidden',
      }}
    >
      {/* Background Image */}
      <Box
        component="img"
        src={images[currentImageIndex]}
        alt={`slider-img-${currentImageIndex}`}
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: 1,
        }}
      />

      {/* Enhanced Gradient Shade */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'linear-gradient(to right, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.3))',
          zIndex: 2,
        }}
      />

      {/* Content Overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: '20%',
          left: '5%',
          zIndex: 3,
          color: 'white',
          textAlign: 'left',
          maxWidth: '40%',
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: 'bold',
            marginBottom: '10px',
            fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' }, // Responsive font size
          }}
        >
          Knowledge is Light
        </Typography>
        <Typography
          variant="body1"
          sx={{
            marginBottom: '20px',
            fontSize: { xs: '0.9rem', sm: '1rem', md: '1.2rem' }, // Responsive font size
          }}
        >
          Education is the key to a brighter future. Join us in spreading the light of knowledge and empowering communities.
        </Typography>
        <Button
          variant="contained"
          sx={{
            backgroundColor: '#FF3F76',
            color: 'white',
            fontWeight: 'bold',
            borderRadius: '20px',
            padding: { xs: '8px 16px', sm: '10px 20px', md: '12px 24px' }, // Responsive padding
            fontSize: { xs: '0.8rem', sm: '1rem', md: '1.2rem' }, // Responsive font size
          }}
          href="#"
        >
          Donate Now
        </Button>
      </Box>
    </Box>
  );
};

export default ImageSlider;
